"use strict";
var AggsContainer_1 = require("./AggsContainer");
function AvgBucketPipeline(key, buckets_path) {
    return AggsContainer_1.AggsContainer(key, { buckets_path: buckets_path });
}
exports.AvgBucketPipeline = AvgBucketPipeline;
//# sourceMappingURL=PipelineAggregations.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/searchkit/lib/src/core/query/query_dsl/aggregations/PipelineAggregations.js
// module id = 438
// module chunks = 0